export const shapes={
  "home": "<path d=\"m3.5 10 8.5-7 8.5 7M5.5 8.5v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11\"/><path d=\"M9.5 20.5v-7h5v7\"/>",
  "idea": "<path d=\"M8.5 16.5a7 7 0 1 1 7 0v2h-7v-2ZM9 21h6M9.5 18.5v-3l-1.25-2M14.5 18.5v-3l1.25-2\"/>",
  "book": "<path d=\"M12 5.5C9 3.6 5.5 3 3 4v15.5c3-1.1 6.5-.5 9 1 2.5-1.5 6-2.1 9-1V4c-2.5-1-6-.4-9 1.5Z\" fill=\"__PAPER__\"/><path d=\"M12 5.5v15M6 8h3M15 8h3\"/>",
  "books": "<rect x=\"3\" y=\"4\" width=\"4.5\" height=\"16\" rx=\".8\" fill=\"__PAPER__\"/><rect x=\"9.5\" y=\"3\" width=\"4.5\" height=\"17\" rx=\".8\" fill=\"__PAPER__\"/><path d=\"m16 5 3.5-.7 3 14.7-3.5.7L16 5Z\" fill=\"__PAPER__\"/><path d=\"M3 8h4.5M9.5 7h4.5\"/>",
  "document-plus": "<path d=\"M13.5 3H5.25A1.25 1.25 0 0 0 4 4.25v15.5A1.25 1.25 0 0 0 5.25 21H11M13.5 3l5 5v3M13.5 3v5h5M7.5 11h7M7.5 14.5H11\"/><path d=\"M18 14v8M14 18h8\"/>",
  "folder": "<path d=\"M3 8V5.25C3 4.56 3.56 4 4.25 4H9l2.5 3H20c.55 0 1 .45 1 1v11c0 .55-.45 1-1 1H4a1 1 0 0 1-1-1V8Z\" fill=\"__PAPER__\"/><path d=\"M3 8h18\"/>",
  "template": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"1.5\" fill=\"__PAPER__\"/><path d=\"M3 8h18M9 8v13M12.5 12h5M12.5 15.5H17\"/>",
  "ai": "<path d=\"m11 3 2.2 5.8L19 11l-5.8 2.2L11 19l-2.2-5.8L3 11l5.8-2.2L11 3Z\" fill=\"__PAPER__\"/><path d=\"M20 3v4M18 5h4M20 17v5M17.5 19.5h5\"/>",
  "document": "<path d=\"M13.5 3H5.25A1.25 1.25 0 0 0 4 4.25v15.5A1.25 1.25 0 0 0 5.25 21h13.5A1.25 1.25 0 0 0 20 19.75V9.5L13.5 3Z\" fill=\"__PAPER__\"/><path d=\"M13.5 3v6.5H20M8 13h8M8 16.5h5.5\"/>",
  "manuscript": "<path d=\"M18 6h2.5v14.25c0 .69-.56 1.25-1.25 1.25H7.5\"/><rect x=\"3.5\" y=\"2.5\" width=\"13\" height=\"16.5\" rx=\"1.25\" fill=\"__PAPER__\"/><path d=\"M7 7h6M7 10.5h6M7 14h4\"/>",
  "cover": "<path d=\"M6 3.5h13v17H6a2.5 2.5 0 0 1-2.5-2.5V6A2.5 2.5 0 0 1 6 3.5Z\" fill=\"__PAPER__\"/><path d=\"M6 3.5v14.25M6 17.75h13M9 7h7M9 10h4\"/>",
  "design": "<rect x=\"3.5\" y=\"3.5\" width=\"17\" height=\"17\" rx=\"1.5\" fill=\"__PAPER__\"/><circle cx=\"15.5\" cy=\"8.5\" r=\"1.5\"/><path d=\"m3.5 16 5.5-5 4.5 4 2-2 5 4.5\"/>",
  "image": "<path d=\"M7 3h13a1 1 0 0 1 1 1v13\"/><rect x=\"3\" y=\"6\" width=\"15\" height=\"15\" rx=\"1.25\" fill=\"__PAPER__\"/><circle cx=\"7.5\" cy=\"10.5\" r=\"1.25\"/><path d=\"m3 17 4-3.5 3 2.5 3.5-4 4.5 5\"/>",
  "profile": "<circle cx=\"12\" cy=\"7.75\" r=\"4\" fill=\"__PAPER__\"/><path d=\"M4.5 21v-1.75a7.5 7.5 0 0 1 15 0V21\"/>",
  "style": "<path d=\"M3.5 5h11M9 5v15M6 20h6M16 10h5M18.5 10v10M16.5 20h4\"/>",
  "assets": "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.2\" fill=\"__PAPER__\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.2\" fill=\"__PAPER__\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1.2\" fill=\"__PAPER__\"/><path d=\"M17.5 14v7M14 17.5h7\"/>",
  "palette": "<path d=\"M12 3a9 9 0 1 0 0 18h1.25a2 2 0 0 0 0-4c-1.3 0-1.7-1.6-.6-2.2.7-.4 1.75-.3 2.85-.3H18a3 3 0 0 0 3-3A9 9 0 0 0 12 3Z\" fill=\"__PAPER__\"/><circle cx=\"7\" cy=\"10\" r=\".8\" fill=\"__INK__\" stroke=\"none\"/><circle cx=\"10.5\" cy=\"6.75\" r=\".8\" fill=\"__INK__\" stroke=\"none\"/><circle cx=\"15\" cy=\"7.75\" r=\".8\" fill=\"__INK__\" stroke=\"none\"/>",
  "format": "<rect x=\"7\" y=\"5\" width=\"13\" height=\"16\" rx=\"1\" fill=\"__PAPER__\"/><path d=\"M3 6v14M1.5 7.5 3 6l1.5 1.5M1.5 18.5 3 20l1.5-1.5M8 1.5h11M9.5 0 8 1.5 9.5 3M17.5 0 19 1.5 17.5 3\"/>",
  "hardcover": "<path d=\"M6.5 3H21v18H6.5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z\" fill=\"__PAPER__\"/><path d=\"M7 3v15M7 18h14M11 7h6.5M11 10.5h5\"/>",
  "paperback": "<path d=\"M5 3.5h12.5v15H5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z\" fill=\"__PAPER__\"/><path d=\"M6 3.5v15M8.5 7H14M8.5 10.5H12M7 21h13.5V6.5\"/>",
  "series": "<rect x=\"3\" y=\"6\" width=\"4.5\" height=\"15\" rx=\".75\" fill=\"__PAPER__\"/><rect x=\"9.75\" y=\"3\" width=\"4.5\" height=\"18\" rx=\".75\" fill=\"__PAPER__\"/><rect x=\"16.5\" y=\"7.5\" width=\"4.5\" height=\"13.5\" rx=\".75\" fill=\"__PAPER__\"/><path d=\"M3 10h4.5M9.75 7h4.5M16.5 11.5H21\"/>",
  "version-history": "<path d=\"M3.5 9a8.75 8.75 0 1 1 .5 8M3.5 3.5V9H9M12 6.5V12l3.75 2.5\"/>",
  "research": "<circle cx=\"10.5\" cy=\"10.5\" r=\"6.75\" fill=\"__PAPER__\"/><path d=\"m15.4 15.4 5.35 5.35\"/>",
  "search": "<circle cx=\"10.5\" cy=\"10.5\" r=\"6.75\" fill=\"__PAPER__\"/><path d=\"m15.4 15.4 5.35 5.35M7.5 9h6M7.5 12.25h4\"/>",
  "keywords": "<path d=\"M4 4h10l7 8-7 8H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z\" fill=\"__PAPER__\"/><circle cx=\"7\" cy=\"12\" r=\"1\" fill=\"__INK__\" stroke=\"none\"/><path d=\"M11 9h4M11 14h4\"/>",
  "niche": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><circle cx=\"12\" cy=\"12\" r=\"3.5\"/><path d=\"M12 2v3M12 19v3M2 12h3M19 12h3\"/>",
  "category": "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.5\" fill=\"__PAPER__\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1.5\" fill=\"__PAPER__\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1.5\" fill=\"__PAPER__\"/><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" rx=\"1.5\" fill=\"__PAPER__\"/>",
  "trend": "<path d=\"M3.5 3.5v17h17M7 15.5l4.5-5 4 2.5 6-8M15.5 5H21v5.5\"/>",
  "keyword-volume": "<path d=\"M4 21v-4M10 21v-6M16 21v-3M21 21V9\"/><circle cx=\"9\" cy=\"8\" r=\"5\" fill=\"__PAPER__\"/><path d=\"m12.5 11.5 4 4\"/>",
  "reverse-asin": "<rect x=\"3\" y=\"8\" width=\"11\" height=\"13\" rx=\"1\" fill=\"__PAPER__\"/><path d=\"M6.5 8v13M17 9V3M17 3l-3 3M17 3l3 3M21 14v5h-4\"/>",
  "saved-search": "<circle cx=\"8.75\" cy=\"9.5\" r=\"5.75\" fill=\"__PAPER__\"/><path d=\"m13 13.75 4.5 4.5M17.5 3H22v9l-2.25-1.5L17.5 12V3Z\"/>",
  "bookmark": "<path d=\"M6 3h12v18l-6-4-6 4V3Z\" fill=\"__PAPER__\"/>",
  "filter": "<path d=\"M3 4h18l-7 8v7.5L10 21v-9L3 4Z\" fill=\"__PAPER__\"/>",
  "sort": "<path d=\"M5 3.5v17M2 17.5l3 3 3-3M11.5 5h10M11.5 10.5h7M11.5 16h4\"/>",
  "publishing": "<path d=\"M12 15V3M7 8l5-5 5 5M3.5 15.5V21h17v-5.5\"/>",
  "a-plus": "<path d=\"m3 20 5.5-16L14 20M5 14h7M18.5 7v10M14.5 12h8\"/>",
  "reviews": "<path d=\"m12 3 2.75 5.6 6.2.9-4.5 4.35 1.05 6.15-5.5-2.9-5.5 2.9 1.05-6.15-4.5-4.35 6.2-.9L12 3Z\" fill=\"__PAPER__\"/>",
  "isbn": "<path d=\"M3.5 4.5v14M7 4.5v14M10.5 4.5v14M14.5 4.5v14M17 4.5v14M20.5 4.5v14M3.5 22h17\"/>",
  "external-link": "<path d=\"M13.5 3H21v7.5M21 3 10.5 13.5M9 4H4a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-5\"/>",
  "marketing": "<rect x=\"3.5\" y=\"13\" width=\"4\" height=\"8\" rx=\".7\" fill=\"__PAPER__\"/><rect x=\"10\" y=\"8.5\" width=\"4\" height=\"12.5\" rx=\".7\" fill=\"__PAPER__\"/><rect x=\"16.5\" y=\"3\" width=\"4\" height=\"18\" rx=\".7\" fill=\"__PAPER__\"/>",
  "target": "<circle cx=\"11\" cy=\"13\" r=\"8\"/><circle cx=\"11\" cy=\"13\" r=\"4.5\"/><path d=\"m11 13 9-9M17 2.5V7h4.5\"/>",
  "campaign": "<path d=\"M3.5 9.5H8L18 5v14L8 14.5H3.5v-5Z\" fill=\"__PAPER__\"/><path d=\"m6 14.5 2 6h3l-1.5-5M21 8l1.5-1.5M21 16l1.5 1.5\"/>",
  "sales": "<path d=\"M3 21h18M5 17v-4h3v4M11 17V9h3v8M17 17V5h3v12M4 8l6-4 4 1 6-3\"/>",
  "calculation": "<path d=\"M6.5 3.25h11a1 1 0 0 1 1 1V21l-3.25-1.9L12 21l-3.25-1.9L5.5 21V4.25a1 1 0 0 1 1-1Z\" fill=\"__PAPER__\"/><path d=\"M9 7h6M14.7 10.75a3.5 3.5 0 1 0 0 5.5M8.25 12h5.5M8.25 14.25H13\"/>",
  "pricing": "<path d=\"M4 3h9.5L21 10.5 10.5 21 3 13.5V4a1 1 0 0 1 1-1Z\" fill=\"__PAPER__\"/><circle cx=\"7.5\" cy=\"7.5\" r=\"1\" fill=\"__INK__\" stroke=\"none\"/><path d=\"m11.5 15 4-4\"/>",
  "royalty": "<circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"__PAPER__\"/><path d=\"M15.5 7.5a5.5 5.5 0 1 0 0 9M6.5 10h8M6.5 13.5h7\"/>",
  "report": "<path d=\"M14 3H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9l-6-6Z\" fill=\"__PAPER__\"/><path d=\"M14 3v6h6M8 17v-3M12 17v-6M16 17v-2\"/>",
  "collection": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"1.5\" fill=\"__PAPER__\"/><path d=\"M3 9h18M9 9v12M15 9v12\"/>",
  "library": "<path d=\"M2.5 21.5h19\"/><rect x=\"3.5\" y=\"4\" width=\"4\" height=\"14\" rx=\".65\" fill=\"__PAPER__\"/><rect x=\"10\" y=\"3\" width=\"4\" height=\"15\" rx=\".65\" fill=\"__PAPER__\"/><path d=\"m16 5 3.5-.7 2.25 13-3.5.7L16 5Z\" fill=\"__PAPER__\"/><path d=\"M3.5 8h4M10 7h4\"/>",
  "settings": "<path d=\"m9.5 3-.6 2.2-2 .9-2.1-.7-2.1 3.7L4.3 11v2l-1.6 1.9 2.1 3.7 2.1-.7 2 .9.6 2.2h4.3l.6-2.2 2-.9 2.1.7 2.1-3.7L19 13v-2l1.6-1.9-2.1-3.7-2.1.7-2-.9-.6-2.2H9.5Z\"/><circle cx=\"11.65\" cy=\"12\" r=\"3.2\"/>",
  "calendar": "<rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"1.5\" fill=\"__PAPER__\"/><path d=\"M7 3v5M17 3v5M3 10.5h18M7.5 14.5h2M14.5 14.5h2M7.5 18h2\"/>",
  "clock": "<circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"__PAPER__\"/><path d=\"M12 6.5V12l4.5 2.5\"/>",
  "help": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M9 8.5a3 3 0 0 1 6 .5c0 2-3 2-3 4.5M12 17h.01\"/>",
  "notification": "<path d=\"M5 17.5h14l-1.75-3V9a5.25 5.25 0 0 0-10.5 0v5.5L5 17.5Z\" fill=\"__PAPER__\"/><path d=\"M9.5 21h5\"/>",
  "import": "<path d=\"M13.5 3H5.25A1.25 1.25 0 0 0 4 4.25v15.5A1.25 1.25 0 0 0 5.25 21h13.5A1.25 1.25 0 0 0 20 19.75V9.5L13.5 3Z\" fill=\"__PAPER__\"/><path d=\"M13.5 3v6.5H20M12 18v-7M8.75 14.25 12 11l3.25 3.25\"/>",
  "export": "<path d=\"M13.5 3H5.25A1.25 1.25 0 0 0 4 4.25v15.5A1.25 1.25 0 0 0 5.25 21h13.5A1.25 1.25 0 0 0 20 19.75V9.5L13.5 3Z\" fill=\"__PAPER__\"/><path d=\"M13.5 3v6.5H20M12 11v7M8.75 14.75 12 18l3.25-3.25\"/>",
  "upload": "<path d=\"M12 16V3M7.5 7.5 12 3l4.5 4.5M3.5 16v5h17v-5\"/>",
  "download": "<path d=\"M12 3v13M7.5 11.5 12 16l4.5-4.5M3.5 16v5h17v-5\"/>",
  "save": "<path d=\"M4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z\" fill=\"__PAPER__\"/><path d=\"M7 3v6h10V3M7 21v-8h10v8\"/>",
  "check": "<path d=\"m4.5 12 5 5 10-11\"/>",
  "plus": "<path d=\"M12 4v16M4 12h16\"/>",
  "copy": "<path d=\"M15.5 5V3H3v12.5h2\"/><rect x=\"8\" y=\"8\" width=\"13\" height=\"13\" rx=\"1.5\" fill=\"__PAPER__\"/>",
  "edit": "<path d=\"m4.5 15.5-1.5 5.5 5.5-1.5L20 8a1.4 1.4 0 0 0 0-2L18 4a1.4 1.4 0 0 0-2 0L4.5 15.5Z\" fill=\"__PAPER__\"/><path d=\"m13.5 6.5 4 4M4.5 15.5l4 4\"/>",
  "delete": "<path d=\"M3.5 6h17M9 6V3h6v3M5.5 6l1 15h11l1-15M10 10v7M14 10v7\"/>",
  "link": "<path d=\"m10 14 4-4M8.5 15.5 7 17a4.25 4.25 0 0 1-6-6l5-5a4.25 4.25 0 0 1 6 0M15.5 8.5 17 7a4.25 4.25 0 0 1 6 6l-5 5a4.25 4.25 0 0 1-6 0\"/>",
  "arrow-right": "<path d=\"M4 12h16M13.5 5.5 20 12l-6.5 6.5\"/>",
  "arrow-left": "<path d=\"M20 12H4M10.5 5.5 4 12l6.5 6.5\"/>",
  "close": "<path d=\"m5.5 5.5 13 13M18.5 5.5l-13 13\"/>",
  "moon": "<path d=\"M20.5 13a8 8 0 0 1-9.5-9.5 9 9 0 1 0 9.5 9.5Z\" fill=\"__PAPER__\"/>",
  "sun": "<circle cx=\"12\" cy=\"12\" r=\"4\" fill=\"__PAPER__\"/><path d=\"M12 2.5V4M12 20v1.5M2.5 12H4M20 12h1.5M5.3 5.3l1.1 1.1M17.6 17.6l1.1 1.1M5.3 18.7l1.1-1.1M17.6 6.4l1.1-1.1\"/>"
};
export const exact={};
export const catalog=[
  {
    "name": "home",
    "label": "Start",
    "category": "Start & Studio"
  },
  {
    "name": "idea",
    "label": "Idee",
    "category": "Start & Studio"
  },
  {
    "name": "book",
    "label": "Buch",
    "category": "Start & Studio"
  },
  {
    "name": "books",
    "label": "Bücher",
    "category": "Start & Studio"
  },
  {
    "name": "document-plus",
    "label": "Buch anlegen",
    "category": "Start & Studio"
  },
  {
    "name": "folder",
    "label": "Projektordner",
    "category": "Start & Studio"
  },
  {
    "name": "template",
    "label": "Vorlage",
    "category": "Start & Studio"
  },
  {
    "name": "ai",
    "label": "KI-Werkzeug",
    "category": "Start & Studio"
  },
  {
    "name": "document",
    "label": "Dokument",
    "category": "Manuskript & Design"
  },
  {
    "name": "manuscript",
    "label": "Manuskript",
    "category": "Manuskript & Design"
  },
  {
    "name": "cover",
    "label": "Cover",
    "category": "Manuskript & Design"
  },
  {
    "name": "design",
    "label": "Designwelt",
    "category": "Manuskript & Design"
  },
  {
    "name": "image",
    "label": "Bild",
    "category": "Manuskript & Design"
  },
  {
    "name": "profile",
    "label": "Profil",
    "category": "Manuskript & Design"
  },
  {
    "name": "style",
    "label": "Zeichenstil",
    "category": "Manuskript & Design"
  },
  {
    "name": "assets",
    "label": "Assets",
    "category": "Manuskript & Design"
  },
  {
    "name": "palette",
    "label": "Farbpalette",
    "category": "Manuskript & Design"
  },
  {
    "name": "format",
    "label": "Buchformat",
    "category": "Manuskript & Design"
  },
  {
    "name": "hardcover",
    "label": "Hardcover",
    "category": "Manuskript & Design"
  },
  {
    "name": "paperback",
    "label": "Paperback",
    "category": "Manuskript & Design"
  },
  {
    "name": "series",
    "label": "Buchreihe",
    "category": "Manuskript & Design"
  },
  {
    "name": "version-history",
    "label": "Versionen",
    "category": "Manuskript & Design"
  },
  {
    "name": "research",
    "label": "Recherche",
    "category": "Recherche"
  },
  {
    "name": "search",
    "label": "Suche",
    "category": "Recherche"
  },
  {
    "name": "keywords",
    "label": "Suchbegriffe",
    "category": "Recherche"
  },
  {
    "name": "niche",
    "label": "Nische",
    "category": "Recherche"
  },
  {
    "name": "category",
    "label": "Kategorien",
    "category": "Recherche"
  },
  {
    "name": "trend",
    "label": "Verlauf",
    "category": "Recherche"
  },
  {
    "name": "keyword-volume",
    "label": "Nachfrage",
    "category": "Recherche"
  },
  {
    "name": "reverse-asin",
    "label": "ASIN-Recherche",
    "category": "Recherche"
  },
  {
    "name": "saved-search",
    "label": "Gespeicherte Suche",
    "category": "Recherche"
  },
  {
    "name": "bookmark",
    "label": "Merkliste",
    "category": "Recherche"
  },
  {
    "name": "filter",
    "label": "Filter",
    "category": "Recherche"
  },
  {
    "name": "sort",
    "label": "Sortieren",
    "category": "Recherche"
  },
  {
    "name": "publishing",
    "label": "Veröffentlichen",
    "category": "Veröffentlichung & A+"
  },
  {
    "name": "a-plus",
    "label": "A+ Content",
    "category": "Veröffentlichung & A+"
  },
  {
    "name": "reviews",
    "label": "Bewertungen",
    "category": "Veröffentlichung & A+"
  },
  {
    "name": "isbn",
    "label": "ISBN",
    "category": "Veröffentlichung & A+"
  },
  {
    "name": "external-link",
    "label": "Extern öffnen",
    "category": "Veröffentlichung & A+"
  },
  {
    "name": "marketing",
    "label": "Marketing",
    "category": "Marketing"
  },
  {
    "name": "target",
    "label": "Ziel",
    "category": "Marketing"
  },
  {
    "name": "campaign",
    "label": "Kampagne",
    "category": "Marketing"
  },
  {
    "name": "sales",
    "label": "Verkäufe",
    "category": "Verkäufe & Kalkulation"
  },
  {
    "name": "calculation",
    "label": "Kalkulation",
    "category": "Verkäufe & Kalkulation"
  },
  {
    "name": "pricing",
    "label": "Preis",
    "category": "Verkäufe & Kalkulation"
  },
  {
    "name": "royalty",
    "label": "Tantiemen",
    "category": "Verkäufe & Kalkulation"
  },
  {
    "name": "report",
    "label": "Bericht",
    "category": "Verkäufe & Kalkulation"
  },
  {
    "name": "collection",
    "label": "Sammlung",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "library",
    "label": "Bibliothek",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "settings",
    "label": "Einstellungen",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "calendar",
    "label": "Kalender",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "clock",
    "label": "Zeit",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "help",
    "label": "Hilfe",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "notification",
    "label": "Mitteilungen",
    "category": "Bibliothek & Konto"
  },
  {
    "name": "import",
    "label": "Import",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "export",
    "label": "Export",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "upload",
    "label": "Hochladen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "download",
    "label": "Herunterladen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "save",
    "label": "Speichern",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "check",
    "label": "Fertig",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "plus",
    "label": "Hinzufügen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "copy",
    "label": "Kopieren",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "edit",
    "label": "Bearbeiten",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "delete",
    "label": "Löschen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "link",
    "label": "Verknüpfen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "arrow-right",
    "label": "Weiter",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "arrow-left",
    "label": "Zurück",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "close",
    "label": "Schließen",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "moon",
    "label": "Dark Mode",
    "category": "Aktionen & Navigation"
  },
  {
    "name": "sun",
    "label": "Light Mode",
    "category": "Aktionen & Navigation"
  }
];
export const tones={sky:['#E5F5FA','#D7E8FF'],mint:['#E5F7F5','#BFEAD9'],lime:['#EDF6E3','#DDECC7'],silver:['#E8EFF9','#DDEBF2']};
export const defaults={"import":"mint","calculation":"mint","design":"lime","assets":"mint","profile":"mint","ai":"lime","category":"mint","saved-search":"mint","bookmark":"lime","publishing":"mint"};
export const metrics={
  "home": {
    "bounds": [
      3.5,
      3,
      17,
      17.5
    ],
    "optical": [
      0.068,
      -1.6
    ]
  },
  "idea": {
    "bounds": [
      5,
      3.43782,
      14,
      17.56218
    ],
    "optical": [
      0.069,
      -0.764
    ]
  },
  "book": {
    "bounds": [
      3,
      3.52167,
      18,
      16.97833
    ],
    "optical": [
      0.067,
      0.776
    ]
  },
  "books": {
    "bounds": [
      3,
      3,
      19.5,
      17
    ],
    "optical": [
      1.305,
      -0.091
    ]
  },
  "document-plus": {
    "bounds": [
      4,
      3,
      18,
      19
    ],
    "optical": [
      1.6,
      0.728
    ]
  },
  "folder": {
    "bounds": [
      3,
      4,
      18,
      16
    ],
    "optical": [
      0.787,
      0.18
    ]
  },
  "template": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.057,
      0.275
    ]
  },
  "ai": {
    "bounds": [
      3,
      3,
      19.5,
      19
    ],
    "optical": [
      -1.003,
      1.114
    ]
  },
  "document": {
    "bounds": [
      4,
      3,
      16,
      18
    ],
    "optical": [
      0.281,
      -0.513
    ]
  },
  "manuscript": {
    "bounds": [
      3.5,
      2.5,
      17,
      19
    ],
    "optical": [
      -0.081,
      -0.238
    ]
  },
  "cover": {
    "bounds": [
      3.5,
      3.5,
      15.5,
      17
    ],
    "optical": [
      0.553,
      0.003
    ]
  },
  "design": {
    "bounds": [
      3.5,
      3.5,
      17,
      17
    ],
    "optical": [
      -0.42,
      0.042
    ]
  },
  "image": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      -0.011,
      0.463
    ]
  },
  "profile": {
    "bounds": [
      4.5,
      3.75,
      15,
      17.25
    ],
    "optical": [
      0.07,
      0.797
    ]
  },
  "style": {
    "bounds": [
      3.5,
      5,
      17.5,
      15
    ],
    "optical": [
      -0.371,
      -0.116
    ]
  },
  "assets": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.9,
      0.9
    ]
  },
  "palette": {
    "bounds": [
      2.99689,
      2.99999,
      18.00311,
      18.00001
    ],
    "optical": [
      0.403,
      0.203
    ]
  },
  "format": {
    "bounds": [
      1.5,
      0,
      18.5,
      21
    ],
    "optical": [
      -0.395,
      -0.256
    ]
  },
  "hardcover": {
    "bounds": [
      3.5,
      3,
      17.5,
      18
    ],
    "optical": [
      0.196,
      -0.117
    ]
  },
  "paperback": {
    "bounds": [
      3,
      3.5,
      17.5,
      17.5
    ],
    "optical": [
      0.136,
      -0.044
    ]
  },
  "series": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.286,
      -1.152
    ]
  },
  "version-history": {
    "bounds": [
      3.5,
      3.5,
      16.76303,
      17.76481
    ],
    "optical": [
      0.25,
      1.318
    ]
  },
  "research": {
    "bounds": [
      3.75,
      3.75,
      17,
      17
    ],
    "optical": [
      0.831,
      0.831
    ]
  },
  "search": {
    "bounds": [
      3.75,
      3.75,
      17,
      17
    ],
    "optical": [
      1.299,
      1.218
    ]
  },
  "keywords": {
    "bounds": [
      3,
      4,
      18,
      16
    ],
    "optical": [
      1.6,
      0.168
    ]
  },
  "niche": {
    "bounds": [
      2,
      2,
      20,
      20
    ],
    "optical": [
      0.061,
      0.061
    ]
  },
  "category": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.062,
      0.063
    ]
  },
  "trend": {
    "bounds": [
      3.5,
      3.5,
      18,
      17
    ],
    "optical": [
      1.103,
      -1.239
    ]
  },
  "keyword-volume": {
    "bounds": [
      4,
      3,
      17,
      18
    ],
    "optical": [
      0.694,
      -0.703
    ]
  },
  "reverse-asin": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      1.196,
      -1.6
    ]
  },
  "saved-search": {
    "bounds": [
      3,
      3,
      19,
      15.25
    ],
    "optical": [
      -1.425,
      1.6
    ]
  },
  "bookmark": {
    "bounds": [
      6,
      3,
      12,
      18
    ],
    "optical": [
      0.067,
      0.314
    ]
  },
  "filter": {
    "bounds": [
      3,
      4,
      18,
      17
    ],
    "optical": [
      0.13,
      1.6
    ]
  },
  "sort": {
    "bounds": [
      2,
      3.5,
      19.5,
      17
    ],
    "optical": [
      1.6,
      0.614
    ]
  },
  "publishing": {
    "bounds": [
      3.5,
      3,
      17,
      18
    ],
    "optical": [
      0.067,
      -1.6
    ]
  },
  "a-plus": {
    "bounds": [
      3,
      4,
      19.5,
      16
    ],
    "optical": [
      1.321,
      -0.477
    ]
  },
  "reviews": {
    "bounds": [
      3.05,
      3,
      17.9,
      17
    ],
    "optical": [
      0.066,
      -1.139
    ]
  },
  "isbn": {
    "bounds": [
      3.5,
      4.5,
      17,
      17.5
    ],
    "optical": [
      -0.112,
      0.065
    ]
  },
  "external-link": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      -0.15,
      0.283
    ]
  },
  "marketing": {
    "bounds": [
      3.5,
      3,
      17,
      18
    ],
    "optical": [
      -1.6,
      -1.6
    ]
  },
  "target": {
    "bounds": [
      3,
      2.5,
      18.5,
      18.5
    ],
    "optical": [
      0.254,
      -0.123
    ]
  },
  "campaign": {
    "bounds": [
      3.5,
      5,
      19,
      15.5
    ],
    "optical": [
      0.758,
      -0.556
    ]
  },
  "sales": {
    "bounds": [
      3,
      2,
      18,
      19
    ],
    "optical": [
      -1.52,
      -1.15
    ]
  },
  "calculation": {
    "bounds": [
      5.5,
      3.25,
      13,
      17.75
    ],
    "optical": [
      0.252,
      0.048
    ]
  },
  "pricing": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      1.57,
      1.6
    ]
  },
  "royalty": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.775,
      0.14
    ]
  },
  "report": {
    "bounds": [
      4,
      3,
      16,
      18
    ],
    "optical": [
      0.163,
      -0.527
    ]
  },
  "collection": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.067,
      -0.096
    ]
  },
  "library": {
    "bounds": [
      2.5,
      3,
      19.25,
      18.5
    ],
    "optical": [
      0.355,
      -0.14
    ]
  },
  "settings": {
    "bounds": [
      2.7,
      3,
      17.9,
      18
    ],
    "optical": [
      0.067,
      0.067
    ]
  },
  "calendar": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.221,
      -0.178
    ]
  },
  "clock": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      -0.217,
      0.277
    ]
  },
  "help": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      -0.071,
      0.937
    ]
  },
  "notification": {
    "bounds": [
      5,
      3.75,
      14,
      17.25
    ],
    "optical": [
      0.07,
      -0.74
    ]
  },
  "import": {
    "bounds": [
      4,
      3,
      16,
      18
    ],
    "optical": [
      0.152,
      -0.37
    ]
  },
  "export": {
    "bounds": [
      4,
      3,
      16,
      18
    ],
    "optical": [
      0.152,
      -0.688
    ]
  },
  "upload": {
    "bounds": [
      3.5,
      3,
      17,
      18
    ],
    "optical": [
      0.067,
      -1.6
    ]
  },
  "download": {
    "bounds": [
      3.5,
      3,
      17,
      18
    ],
    "optical": [
      0.067,
      -1.6
    ]
  },
  "save": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.34,
      -0.077
    ]
  },
  "check": {
    "bounds": [
      4.5,
      6,
      15,
      11
    ],
    "optical": [
      -0.063,
      -1.062
    ]
  },
  "plus": {
    "bounds": [
      4,
      4,
      16,
      16
    ],
    "optical": [
      0.064,
      0.064
    ]
  },
  "copy": {
    "bounds": [
      3,
      3,
      18,
      18
    ],
    "optical": [
      0.633,
      0.635
    ]
  },
  "edit": {
    "bounds": [
      3,
      3.5798,
      17.4202,
      17.4202
    ],
    "optical": [
      0.351,
      -0.213
    ]
  },
  "delete": {
    "bounds": [
      3.5,
      3,
      17,
      18
    ],
    "optical": [
      0.067,
      0.383
    ]
  },
  "link": {
    "bounds": [
      -0.07322,
      4.7604,
      24.14644,
      14.4792
    ],
    "optical": [
      0.05,
      0.051
    ]
  },
  "arrow-right": {
    "bounds": [
      4,
      5.5,
      16,
      13
    ],
    "optical": [
      -1.6,
      0.076
    ]
  },
  "arrow-left": {
    "bounds": [
      4,
      5.5,
      16,
      13
    ],
    "optical": [
      1.6,
      0.076
    ]
  },
  "close": {
    "bounds": [
      5.5,
      5.5,
      13,
      13
    ],
    "optical": [
      0.076,
      0.078
    ]
  },
  "moon": {
    "bounds": [
      2.51473,
      3.5,
      17.98527,
      17.98527
    ],
    "optical": [
      1.146,
      -1.01
    ]
  },
  "sun": {
    "bounds": [
      2.5,
      2.5,
      19,
      19
    ],
    "optical": [
      0.061,
      0.061
    ]
  }
};
export const opticalSizes={plus:37,check:41,close:37,ai:41,category:41,assets:42,isbn:40,style:42,sun:42};
export const family={version:3,canvas:96,anchor:[48,45],badgeStroke:3,plainStroke:2,mainCircle:[48,45,35],accentCircle:[68,68,21]};
export function iconSvg(name,{tone=defaults[name]||'sky',badged=true,theme='light',size=badged?96:24,guides=false}={}){
if(!shapes[name])throw Error('Unknown icon '+name);if(!tones[tone])throw Error('Unknown tone');if(!['light','dark'].includes(theme))throw Error('Unknown theme');if(!Number.isFinite(Number(size))||Number(size)<16||Number(size)>2048)throw Error('Size must be 16..2048');
const m=metrics[name];if(!m)throw Error('Missing optical calibration for '+name);const[x,y,w,h]=m.bounds;
const target=badged?(opticalSizes[name]||44):20,scale=target/Math.max(w,h),shift=badged?m.optical:m.optical.map(v=>v*.22);
const anchor=badged?family.anchor:[12,12],tx=anchor[0]-(x+w/2)*scale+shift[0],ty=anchor[1]-(y+h/2)*scale+shift[1];
const ink=badged?'#17252F':theme==='dark'?'#F2F6FA':'#17252F';
const art=shapes[name].replaceAll('__PAPER__',badged?'#FBFDFE':'none').replaceAll('__INK__',ink);
const c=tones[tone],backdrop=badged?'<circle cx="48" cy="45" r="35" fill="'+c[0]+'"/><circle cx="68" cy="68" r="21" fill="'+c[1]+'"/>':'';
const stroke=(badged?family.badgeStroke:family.plainStroke)/scale;
const guide=guides&&badged?'<circle cx="48" cy="45" r="25" fill="none" stroke="#E64C82" stroke-width=".5" stroke-dasharray="2 2"/><path d="M42 45h12M48 39v12" stroke="#E64C82" stroke-width=".5"/>':'';
return '<svg xmlns="http://www.w3.org/2000/svg" width="'+size+'" height="'+size+'" viewBox="0 0 '+(badged?'96 96':'24 24')+'" fill="none">'+backdrop+'<g transform="translate('+tx.toFixed(4)+' '+ty.toFixed(4)+') scale('+scale.toFixed(5)+')" stroke="'+ink+'" stroke-width="'+stroke.toFixed(5)+'" stroke-linecap="round" stroke-linejoin="round">'+art+'</g>'+guide+'</svg>';
}
